module.exports = "/static/assets/89a5687599f173f2b910aa5fcd862b42.svg";